// extracted by mini-css-extract-plugin
export default {"battle-log":"BattleLog_battle-log__9JM4x","battle-log-info":"BattleLog_battle-log-info__d8KKp","battle-log-text":"BattleLog_battle-log-text__Nj42M"};